import { call, put, takeLatest } from 'redux-saga/effects';

import { copy, getData, reSend } from '../../services/API/3ndflView';
import {
  actionTypes,
  copyFailure,
  copySuccess,
  getDataFailure,
  getDataSuccess,
  reSendFailure,
  reSendSuccess,
} from './actions';

import processData from './dataHelper';

function* get3NDFLData(action) {
  try {
    const response = yield call(getData, action.payload);

    if (response.isOk) {
      const processedData = processData(response.data);
      yield put(getDataSuccess(processedData));
    } else {
      yield put(getDataFailure(response.error));
    }
  } catch (error) {
    yield put(getDataFailure(error));
  }
}

function* ndfl3DataSaga() {
  yield takeLatest(actionTypes.GET_DATA, get3NDFLData);
}

/**
 * Create and send specified declaration
 * @param {Object} action
 */
function* copy3NDFL(action) {
  try {
    const response = yield call(copy, action.payload);

    yield put(response.isOk ? copySuccess(response.data) : copyFailure(response.error));
  } catch (error) {
    yield put(copyFailure(error));
  }
}

function* ndfl3CopySaga() {
  yield takeLatest(actionTypes.COPY, copy3NDFL);
}

/**
 * Edit declaration and re-send
 * @param {Object} action
 */
function* resend3NDFL(action) {
  try {
    const response = yield call(reSend, action.payload);

    yield put(response.isOk ? reSendSuccess(response.data) : reSendFailure(response.error));
  } catch (error) {
    yield put(reSendFailure(error));
  }
}

function* ndfl3ReSendSaga() {
  yield takeLatest(actionTypes.RE_SEND, resend3NDFL);
}

export { ndfl3DataSaga, ndfl3CopySaga, ndfl3ReSendSaga };
